import { PolicyLayout } from "@/components/PolicyLayout";

const H = ({ children }) => <h2 className="font-heading text-xl sm:text-2xl font-700 text-slate-800 mt-8 first:mt-0">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-slate-600 font-600 leading-relaxed">{children}</p>;
const UL = ({ children }) => <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-600 font-600">{children}</ul>;

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy" updated="Giugno 2026">
      <P>
        La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che
        consultano il sito dell'Asilo Nido Per Amore e che utilizzano il modulo di contatto, ai sensi del
        Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 e s.m.i.
      </P>

      <H>Titolare del trattamento</H>
      <P>
        Asilo Nido Per Amore — Via Strasburgo 3/b, San Donato Milanese (MI) 20097.<br />
        Email: asilonidoperamore@gmail.com — Telefono: 338 734 8963.
      </P>

      <H>Quali dati raccogliamo</H>
      <P>Tramite il modulo "Richiedi Informazioni" raccogliamo i dati che fornisci volontariamente:</P>
      <UL>
        <li>Nome e cognome</li>
        <li>Indirizzo email</li>
        <li>Numero di telefono (facoltativo)</li>
        <li>Il contenuto del messaggio</li>
      </UL>
      <P>
        Durante la navigazione, previo tuo consenso, possono essere raccolti dati tecnici e di utilizzo tramite
        cookie e strumenti di terze parti (vedi la Cookie Policy).
      </P>

      <H>Finalità e base giuridica</H>
      <UL>
        <li>Rispondere alle richieste di informazioni e iscrizione — base giuridica: esecuzione di misure precontrattuali su tua richiesta (art. 6.1.b GDPR).</li>
        <li>Statistiche e marketing (es. Google Analytics, Google Ads) — base giuridica: consenso (art. 6.1.a GDPR), revocabile in qualsiasi momento.</li>
      </UL>

      <H>Modalità di trattamento e conservazione</H>
      <P>
        I dati del modulo vengono memorizzati in un database sicuro e inviati via email al Titolare tramite il
        servizio di invio email Resend. I dati sono conservati per il tempo necessario a gestire la tua
        richiesta e, successivamente, per gli obblighi di legge, dopodiché vengono cancellati o anonimizzati.
      </P>

      <H>Destinatari dei dati</H>
      <P>I dati possono essere trattati da fornitori che agiscono come responsabili del trattamento, tra cui:</P>
      <UL>
        <li>Resend (servizio di invio email)</li>
        <li>Google (Google Tag Manager, Google Ads/Analytics), solo previo consenso</li>
        <li>Fornitore di hosting del sito</li>
      </UL>
      <P>I dati non sono diffusi né ceduti a terzi per finalità non indicate nella presente informativa.</P>

      <H>I tuoi diritti</H>
      <P>In qualità di interessato puoi esercitare in qualsiasi momento i diritti previsti dagli artt. 15-22 GDPR:</P>
      <UL>
        <li>Accesso, rettifica e cancellazione dei dati</li>
        <li>Limitazione e opposizione al trattamento</li>
        <li>Portabilità dei dati</li>
        <li>Revoca del consenso in qualsiasi momento</li>
        <li>Reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it)</li>
      </UL>
      <P>Per esercitare i tuoi diritti scrivi a: asilonidoperamore@gmail.com</P>

      <H>Modifiche</H>
      <P>
        Il Titolare si riserva di aggiornare la presente informativa. Ti invitiamo a consultarla periodicamente;
        la data di ultimo aggiornamento è indicata in alto.
      </P>
    </PolicyLayout>
  );
}
